module.exports = __webpack_public_path__ + "static/media/logo_viacredi.db346923.svg";